// extracted by mini-css-extract-plugin
export var card = "metamorphosis-card-module--card--2309d";
export var content = "metamorphosis-card-module--content--a58c8";
export var icon = "metamorphosis-card-module--icon--55589";
export var imgBox = "metamorphosis-card-module--img-box--a7225";
export var name = "metamorphosis-card-module--name--b213b";
export var ratioClass = "metamorphosis-card-module--ratio-class--3410a";
export var text = "metamorphosis-card-module--text--eafb5";